import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import ListBuilder from '../../../components/listBuilder';
import ErrorModal from '../../../components/errorModal';
import { getSearchParams, generateSearchLink, generateSearchLinkMultiple } from '../../../helpers/linkHelper';
import { API_ENDPOINT } from '../../../constants';
import viewIcon from '../../../assets/svg/eye.svg';
import refundIcon from '../../../assets/svg/refund-icon.svg';
import historyIcon from '../../../assets/svg/history-icon.svg';
import editPaymentIcon from '../../../assets/svg/edit.svg';
import cancelPaymentIcon from '../../../assets/svg/cancel-payment-icon.svg';
import addIcon from '../../../assets/svg/add-icon.svg';


import xIcon from '../../../assets/svg/x.svg';
import garbageIcon from '../../../assets/svg/garbage.svg';
import walletIcon from '../../../assets/svg/wallet.svg';
import warrning from '../../../assets/svg/warrning.svg';
import attachInvoice from '../../../assets/svg/attach.svg'
import edit from '../../../assets/svg/edit-payment-icon.svg'
import labelIcon from '../../../assets/svg/label-icon.svg'
import markPaymentIcon from '../../../assets/svg/markPaymentIcon.svg'
import adjustFreeCardIcon from '../../../assets/svg/adjust-free-card.svg'
import removeDocumentIcon from '../../../assets/svg/remove-document.svg'


import Payson from '../../../components/payson';
import Swish from '../../swish';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import PdfSave from '../../../components/pdvSave';
import InfoModal from '../../../components/infoModal';
import striptags from 'striptags';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import downloadIcon from '../../../assets/svg/download.svg';
import deleteDocument from '../../../assets/svg/delete-document.svg'
import barsIcon from '../../../assets/svg/bars-icon.svg';
import newTab from '../../../assets/svg/newtab.svg';



import billGrey from '../../../assets/svg/bill_grey.svg';
import infoIcon from "../../../assets/svg/link-new-tab.svg";
import DatePicker from '../../../components/forms/fields/datePicker';
import Checkbox from '../../../components/forms/fields/checkbox';
import DeleteModal from '../../../components/deleteModal';
import PatientNotesPreview from '../../../components/patientNotesPreview';
import CustomFilters from './customFilters';
import CreatePayment from './createPayment';
import EditPayment from './editPayment';
import RegisterPayment from './registerPayment';
import { getExtendedPaymentManagement, getHumanReadableLabel, getHumanReadablePaymentMethod, getHumanReadableStatus, getUserPaymentPermissions } from '../helper';
import MarkAsPaid from './markAsPaid';
import MarkAsUnpaid from './markAsUnpaid';
import PreviewPayment from './previewPayment';
import ReferralStatusHistoryModal from '../../../components/referralStatusHistoryModal';
import RefundPayment from './refundPayment';
import CancelPayment from './cancelPayment';
import AttachInvoice from './attachInvoice';
import AddLabel from './addLabel';
import AdjustFreeCardCoverage from './adjustFreeCardCoverage';
import RemoveAttachedInvoice from './removeAttachedInvoice';

function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}

class EventPreviewPaymentField extends Component {
    constructor(props) {
        super(props);

        this.barsMenuContainer = React.createRef();

        this.state = {
            ...props.initialData,
            items: [],
        };
    }
    getPayments = () => {
        const caseId = this.props.caseId ?? null;
        if (!caseId) {
            if (this.state.items?.length) {
                this.setState({ items: [] })
            }
            return;
        }

        fetch(API_ENDPOINT + `/api/payments/case/${caseId}`, {
            method: 'GET',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            }
        }).then(res => res.json()).then((result) => {
            let items = result?.items ?? [];
            let patientId = result?.patientId ?? null;
            this.setState({ items, patientId });
        })
    }

    get = () => {
        this.getPayments();


    }

    componentDidMount() {
        if (typeof window !== 'undefined') { window.scrollTo(0, 0); }

        this.get();


        this.interval = setInterval(() => {
            this.get();
        }, 60 * 1000);


        this.initializeSocket();

        document.addEventListener('mousedown', this.handleClickOutsideBarsMenuContainer);

        const userPaymentPermissions = getUserPaymentPermissions(this.props.uData, this.props.selectedGroup, this.props.selectedClinic);
        this.setState({ userPaymentPermissions });

    }
    handleClickOutsideBarsMenuContainer = (event) => {
        if (event && event.target && this.barsMenuContainer && this.barsMenuContainer.contains && !this.barsMenuContainer.contains(event.target)) {
            if (this.state.activeBarsMenu) {
                this.setState({ activeBarsMenu: false })
            }
        }
    }

    initializeSocket = () => {
        if (this.props.uData && this.props.socket && !this.state._registerEvents) {
            this.setState({
                _registerEvents: true
            }, () => {
                this.registerEvents();
            })
        } else {
            this.socketInterval = setInterval(() => {
                if (this.props.uData && this.props.socket && !this.state._registerEvents) {
                    if (this.socketInterval) {
                        clearInterval(this.socketInterval)
                    }

                    this.setState({
                        _registerEvents: true
                    }, () => {
                        this.registerEvents();


                    })
                }
            }, 150);
        }
    }
    registerEvents = async () => {
        this.props.socket.on('newPayment', (data) => {
            this.get();
        })
    }

    componentWillUnmount() {
        if (this.interval) clearInterval(this.interval);

        if (this.props.socket) {
            this.props.socket.removeListener('newPayment');
        }

        window.removeEventListener('mousedown', this.handleClickOutsideBarsMenuContainer);
    }

    componentDidUpdate(prevProps) {
        if (prevProps[0].location.search != this.props[0].location.search) {
            this.setState({
                loading: true
            }, () => {
                this.get();

            })
        }

        if (prevProps.caseId != this.props.caseId) {
            this.get();
        }

    }



    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }

        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;

        return groupData;
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }
    searchPatientWithRedirect = (SSN, enterprise) => {
        let obj = {
            socialSecurityNumber: SSN,
            group: this.props.selectedGroup,
            clinic: this.props.selectedClinic,
        }
        enterprise && (obj.openOnWebDoc = true);

        fetch(API_ENDPOINT + '/users/find/patient', {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(obj)
        }).then(res => res.json()).then((result) => {
            //result = result?.error ? result?.error : result?.length ? result[0] : null;
            if (result && result._id) {
                const path = enterprise ? '/patients/search-enterprise' : '/patients/search';
                this.props.registerClinicGroupLogs({
                    type: 'patientProfile',
                    patient: SSN,
                });

                let state = {
                    TYPE: 'redirect',
                    redirectPatient: result,
                    redirectTabIndex: 1
                }
                enterprise && (state.redirectTabActive = 1);

                this.props[0].history.push(path, state);

            } else {
                this.setState({ error: 'User not found in this clinic group' })
            }
        })
    }

    getListData = () => {
        const groupData = this.getGroupData();


        const enterprise = groupData?.enterprise;
        const canSearchPatients = groupData?.sarchPatients;

        const patientInfoSettings = groupData?.patientInfoSettings;
        const isCustomIdEnabled = patientInfoSettings?.isCustomIdEnabled;
        const groupId = this.props.selectedGroup;
        const clinicId = this.props.selectedClinic;
        const currency = this.getCurrency();
        const defaultValue = 'N/A'.translate(this.props.lang)


        let listFields = [
            { type: 'text', name: 'caseNumber', label: 'Case ID'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'clinicInfo', label: 'Recipient'.translate(this.props.lang), allowSort: false },
            { type: 'text', name: 'patient', label: 'Patient'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitReason', label: 'Visit reason'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'visitDate', label: 'Visit date'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'paymentMethod', label: 'Payment method'.translate(this.props.lang), allowSort: true }, // TODO
            { type: 'text', name: 'reference', label: 'Reference'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'price', label: 'Price'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'vatValueString', label: 'Varav moms'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'tsCreated', label: 'Created'.translate(this.props.lang), allowSort: true },
            { type: 'text', name: 'status', label: 'Status'.translate(this.props.lang), allowSort: true },
        ];

        const items = this.state.items?.length ? this.state.items : [];
        const listItems = items?.map((item => {
            const caseData = item?.caseData || {};
            const doctorName = caseData?.doctorName ?? item?.createdByUser?.name ?? null;
            const { groupName, clinicName, clinicSubgroupName } = item?.clinicInfo || {};
            const { name: patientName, ssn: patientSSN, customId: patientCustomId } = item?.patientData || {};
            const amount = item?.amount?.value;
            const _currency = item?.amount?.currency || currency;
            const price = `${amount} ${_currency}`;

            const vatValue = item?.vat?.value ? Number(item.vat.value) : 0;
            const vat = typeof vatValue === 'number' ? vatValue?.toFixed(2) : '0.00';
            const vatValueString = `${vat} ${_currency}`;

            const basicInfo = item?.currentStatus ?? item?.status?.[0];
            const __status = item?.currentStatus?.status?.key ?? basicInfo?.status?.key;
            const __statusName = getHumanReadableStatus(__status, this.props.lang);

            const paymentMethod = basicInfo?.paymentMethod?.key ?? defaultValue;

            const reference = basicInfo?.reference ?? defaultValue;

            return {
                ...item,
                _status: __status,
                caseNumber: item?.paymentNumber,
                clinicInfo: <div className='list-builder-field-clinic-info' style={{ minWidth: 100 }}>{clinicName}<span>{clinicSubgroupName ? <><br />{clinicSubgroupName}</> : null}{doctorName ? <><br />{doctorName}</> : null}</span></div>,
                patient: <Button
                    color='#fff'
                    className="patient-modal-button"
                    onClick={() => {
                        if (!patientSSN) return;
                        if (enterprise || canSearchPatients) {
                            this.searchPatientWithRedirect(patientSSN, enterprise);
                        }
                    }}
                >
                    {patientName}
                    <span className="clinic-subgroup-name">
                        {patientSSN ? <><br />{patientSSN}</> : null}
                        {isCustomIdEnabled && patientCustomId?.[groupId] ? <><br />{patientCustomId[groupId]} </> : null}
                    </span>

                </Button>,
                visitReason: caseData?.questionaryName ?? defaultValue,
                visitDate: caseData?.visitDate?.se ?? defaultValue,
                price: price ?? defaultValue,
                vatValueString: vatValueString ?? defaultValue,
                tsCreated: item.tsCreated ? this.props.getStringDateTs(item.tsCreated, this.props.dateFormat + ' HH:mm') : defaultValue,
                status: <div className='list-builder-field-status'>{__statusName ?? defaultValue}</div>,
                paymentMethod: paymentMethod ? getHumanReadablePaymentMethod(paymentMethod, this.props.lang) : null,
                reference: reference

                // <div className='list-builder-field-patient-info'>{patientName}<span>{patientSSN ? <><br />{patientSSN}</> : null}{isCustomIdEnabled && patientCustomId?.[groupId] ? <><br />{patientCustomId[groupId]}</> : null}</span></div>
            }
        }))

        return {
            listFields,
            listItems
        }
    }
    openNotes = async (item, type) => {
        if (!item) return;
        const paymentId = item?._id;
        let patientNotes = await this.checkPatientNotes(paymentId);

        let patientNotesReferralId;

        let _item = JSON.parse(JSON.stringify(item));
        if (patientNotes) {
            _item.patientNotes = patientNotes?.items ?? [];
            patientNotesReferralId = patientNotes?.caseId;
        }
        this.setState({ paymentNotes: _item, patientNotesReferralId })

    }
    checkPatientNotes = async (paymentId) => {

        if (!paymentId) {
            return [];
        }
        let data = {
            paymentId,
            clinicId: this.props.selectedClinic,
            groupId: this.props.selectedGroup,
            lang: this.props.lang
        };
        let result = await fetch(API_ENDPOINT + `/user/patients-notes/fetch`, {
            method: 'POST',
            headers: {
                'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                'content-type': 'application/json'
            },
            body: JSON.stringify(data)
        })
        try {
            let response = await result.json();
            let items = [], caseId;
            if (response?.items?.length) {
                items = response.items;
            }
            if (response?.caseId) {
                caseId = response.caseId;
            }
            return {
                items, caseId
            }

        } catch (error) {
            console.error('Error fetching patient notes:', error);
            return [];

        }


    }
    addNewNote = () => {
        const item = this.state.paymentNotes;
        const note = this.state.notesPaymentText?.trim() ?? '';
        const paymentId = item?._id;

        const data = {
            note,
            paymentId
        }

        this.setState({ loadingAddNote: true }, () => {
            fetch(API_ENDPOINT + '/api/payments/note/insert', {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(res => res.json()).then((result) => {
                if (result && result.error) {
                    this.setState({ loadingAddNote: false, notesPaymentText: '', error: result.error });
                    this.get();
                } else if (result && result.success) {
                    this.setState({ loadingAddNote: false, notesPaymentText: '', paymentNotes: null });
                    this.get();
                }
            })
        })



    }

    render() {
        const currency = this.getCurrency();

        const userPaymentPermissions = this.state.userPaymentPermissions || {};

        const groupData = this.getGroupData();

        const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);

        let enterprise = groupData?.enterprise;
        let canSearchPatients = groupData?.sarchPatients;

        const patientInfoSettings = groupData?.patientInfoSettings;


        // const { listFields, listItems } = this.getListData();
        const caseId = this.props.caseId ?? null;
        const items = this.state.items ?? [];
        const patientId = this.state.patientId ?? null;


        const showCreatePaymentButton = caseId && patientId && EXTENDED_PAYMENT_MANAGEMENT ? true : false;
        const ActionsButtons = (item, idx) => {
            const labels = item?.labels?.map(label => label.label?.key) || [];
            const isPaymentCancelled = labels?.includes('payment_cancelled');
            const isPatientDeleted = labels?.includes('patient_deleted');
            const isCaseDeleted = labels?.includes('case_deleted');
            const paymentMethod = item?.currentStatus?.paymentMethod?.key ?? null;
            const requestedFreeCardPayment = item?.currentStatus?.paymentMethod?.key === 'freeCard' ? true : false;
            const price = item?.amount?.value ? Number(item?.amount?.value) : 0;

            const status = item?.currentStatus?.status?.key ?? null;
            const requestedInvoice = paymentMethod === 'invoice' ? true : false;
            const attachedInvoiceExists = item?.attachedInvoice && requestedInvoice ? true : false;
            const requestedPaymentOnSite = paymentMethod === 'paymentOnSite';
            const attachInvoiceCondition = ['UNPAID']?.indexOf(status) > -1 && requestedInvoice && !attachedInvoiceExists && userPaymentPermissions?.attachInvoices ? true : false;
            const downloadInvoiceCondition =  /*['UNPAID']?.indexOf(status) > -1 &&*/ requestedInvoice && attachedInvoiceExists ? true : false;
            const removeAttachedInvoiceCondition = ['UNPAID']?.indexOf(status) > -1 && requestedInvoice && attachedInvoiceExists && userPaymentPermissions?.attachInvoices ? true : false;
            const showReceiptCondition = ["PAID", "REFUNDED", "PARTIALLY_REFUNDED"]?.indexOf(status) > -1 ? true : false;
            const markAsPaidCondition = ['UNPAID']?.indexOf(status) > -1 && !isPaymentCancelled && !isPatientDeleted && !isCaseDeleted && !requestedPaymentOnSite && userPaymentPermissions?.markAsPaidAndRegisterPayment && EXTENDED_PAYMENT_MANAGEMENT ? true : false;
            const markAsUnpaidCondition = ["PAID"]?.indexOf(status) > -1 && ['registeredManually', 'freeCard']?.includes(paymentMethod) && userPaymentPermissions?.markAsPaidAndRegisterPayment && EXTENDED_PAYMENT_MANAGEMENT ? true : false;
            const refundPaymentCondition = ["PAID", "PARTIALLY_REFUNDED"]?.indexOf(status) > -1 && price > 0 && EXTENDED_PAYMENT_MANAGEMENT && userPaymentPermissions?.refundPayments ? true : false;
            const registerPaymentCondition = ["UNPAID"]?.indexOf(status) > -1 && !isPaymentCancelled && !isPatientDeleted && !isCaseDeleted && (attachedInvoiceExists || requestedPaymentOnSite) && userPaymentPermissions?.markAsPaidAndRegisterPayment ? true : false;
            const adjustFreeCardCoverageCondition = ["UNPAID"]?.indexOf(status) > -1 && requestedFreeCardPayment && !isPaymentCancelled && !isPatientDeleted && !isCaseDeleted && userPaymentPermissions?.editPayments ? true : false;
            const viewHistoryCondition = true;
            const editPaymentCondition = ["UNPAID"]?.indexOf(status) > -1 && !isPaymentCancelled && !isPatientDeleted && !isCaseDeleted && EXTENDED_PAYMENT_MANAGEMENT && userPaymentPermissions?.editPayments ? true : false;
            const cancelPaymentCondition = ["UNPAID"]?.indexOf(status) > -1 && !isPaymentCancelled && userPaymentPermissions?.cancelPayments ? true : false;
            const addLabelCondition = true;
            return (
                <>
                    <div
                        className='action-bars-list-builder-menu'
                        style={{ cursor: 'pointer' }}
                        onClick={(e) => {
                            e.stopPropagation();
                            this.openNotes(item);
                        }}>
                        <div className="tabel-action-tooltip" >
                            <Isvg src={infoIcon} className={item?.notes?.length || item?.hasPatientNotes ? 'note-icon-wrap note-icon-green' : "note-icon-wrap"} />
                            <div className="chat-icons-tooltip" style={{ whiteSpace: 'nowrap' }}>
                                <span>{item?.notes?.length || item?.hasPatientNotes ? 'Notes available'.translate(this.props.lang) : 'Note'.translate(this.props.lang)}</span>
                            </div>
                        </div>
                    </div>
                    <div
                        className="action-bars-list-builder-wrap"
                        onClick={() => {
                            let key = `menu-${idx}`;
                            this.setState({ activeBarsMenu: this.state.activeBarsMenu == key ? null : key })
                        }}
                    >
                        <Isvg src={barsIcon} />



                        {
                            this.state.activeBarsMenu === `menu-${idx}` ?
                                <div className='action-bars-list-builder-menu-wrap' ref={(node) => this.barsMenuContainer = node}>
                                    <div className='action-bars-list-builder-menu'>
                                        {
                                            showReceiptCondition ?
                                                <button

                                                    onClick={(e) => {
                                                        this.setState({ previewPayment: item });
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={viewIcon} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Receipt'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                : null
                                        }
                                        {/* {
                                            addLabelCondition ?
                                                <button

                                                    onClick={(e) => {
                                                        this.setState({ addLabelModal: item?._id });
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={labelIcon} className="add-label-icon" style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Add label'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                : null
                                        } */}

                                        {
                                            attachInvoiceCondition ?
                                                <button
                                                    onClick={(e) => {
                                                        this.setState({ attachInvoiceModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={attachInvoice} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Attach invoice'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            downloadInvoiceCondition ?
                                                <button
                                                    onClick={(e) => {
                                                        if (typeof window !== 'undefined') {
                                                            // let url = API_ENDPOINT + item.attachedInvoice + `?mt=${this.props.uData ? this.props.uData.mediaToken : ''}&rid=${item._id}`;
                                                            let url = API_ENDPOINT + item.attachedInvoice;
                                                            window.open(url, '_blank')
                                                        }
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={downloadIcon} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Download invoice'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            removeAttachedInvoiceCondition ?
                                                <button
                                                    onClick={(e) => {
                                                        this.setState({ removeAttachedInvoiceModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={removeDocumentIcon} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Remove attached invoice'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }

                                        {
                                            markAsPaidCondition ?
                                                <button
                                                    onClick={(e) => {
                                                        this.setState({ markAsPaidModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={markPaymentIcon} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Mark as paid'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            markAsUnpaidCondition ?
                                                <button
                                                    onClick={(e) => {
                                                        this.setState({ markAsUnpaidModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip">
                                                        <Isvg src={edit} style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Mark as unpaid'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            refundPaymentCondition ?
                                                <button
                                                    onClick={() => {
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ refundPaymentModal: paymentId })
                                                    }}>
                                                    <div className="tabel-action-tooltip">
                                                        <Isvg src={refundIcon} className='refund-icon-svg' style={{ width: 24, minWidth: 24 }} />
                                                        <div style={{ width: 180 }} className="chat-icons-tooltip">{'Refund payment'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            adjustFreeCardCoverageCondition ?
                                                <button
                                                    onClick={() => {
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ adjustFreeCardCoverageModal: paymentId })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={adjustFreeCardIcon} className="wallet-icon" />
                                                        <div className="chat-icons-tooltip">{'Adjust free card coverage'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }

                                        {
                                            registerPaymentCondition ?
                                                <button
                                                    onClick={() => {
                                                        this.setState({ registerPaymentModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={walletIcon} className="wallet-icon" />
                                                        <div className="chat-icons-tooltip">{'Register payment'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            viewHistoryCondition ?
                                                <button
                                                    onClick={() => {
                                                        this.setState({ statusHistoryModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={historyIcon} className="view-history-icon" />
                                                        <div className="chat-icons-tooltip">{'View history'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            editPaymentCondition ?
                                                <button
                                                    onClick={() => {
                                                        const paymentId = item?._id;
                                                        if (!paymentId) return;
                                                        this.setState({ editPaymentModal: paymentId })
                                                    }}>
                                                    <div className="tabel-action-tooltip">
                                                        <Isvg src={editPaymentIcon} className="view-history-icon" />
                                                        <div className="chat-icons-tooltip">{'Edit payment'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            cancelPaymentCondition ?
                                                <button
                                                    onClick={() => {
                                                        // TODO: Cancel payment
                                                        this.setState({ cancelPaymentModal: item })
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={cancelPaymentIcon} className="cancel-payment-icon" />
                                                        <div className="chat-icons-tooltip">{'Cancel payment'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }
                                        {
                                            true ?
                                                <button
                                                    onClick={() => {
                                                        this.props[0].history.push(`/my-data/clinic/payments?filter=${item.paymentNumber}`);
                                                    }}>
                                                    <div className="tabel-action-tooltip" >
                                                        <Isvg src={newTab} className="open-payment-icon" />
                                                        <div className="chat-icons-tooltip">{'Open payment'.translate(this.props.lang)}</div>
                                                    </div>
                                                </button>
                                                :
                                                null
                                        }

                                    </div>
                                </div>
                                :
                                null
                        }
                    </div>
                </>
            )
        }
        return (
            <div className='event-preview-payment-field-wrap'>
                <h6>{'Payment'.translate(this.props.lang)}</h6>

                <div className='event-preview-payment-field-list'>
                    {
                        items?.map((item, idx) => {
                            const amount = item?.amount?.value;
                            const _currency = item?.amount?.currency || currency;
                            const price = `${amount} ${_currency}`;
                            const statusKey = item?.currentStatus?.status?.key;
                            const status = statusKey ? getHumanReadableStatus(statusKey, this.props.lang) : 'N/A'.translate(this.props.lang);
                            const statusColorClassName = statusKey === 'PAID' ? 'green-box' : statusKey === 'UNPAID' ? 'red-box' : 'orange-box';
                            let _labels = [];
                            if (item?.labels?.length) {
                                for (let i = item.labels.length - 1; i >= 0; i--) {
                                    if (!_labels.find(el => el.label?.key === item.labels[i].label?.key)) {
                                        _labels.push(item.labels[i]);
                                    }
                                }
                                _labels = _labels.reverse();
                            }
                            const labels = _labels?.length ? _labels.map((label, lIdx) => {
                                let _label = getHumanReadableLabel(label.label?.key, this.props.lang);

                                return (
                                    <div key={lIdx} className='payment-label'>
                                        {_label}
                                    </div>
                                )
                            }) : null;
                            return (
                                <div className='event-preview-payment-field-list-item' key={idx}>
                                    <div className='price-item'>{price}</div>
                                    <div className='status-item-wrap'>
                                        <div className={`status-item ${statusColorClassName}`}>
                                            {status}

                                        </div>
                                        {
                                            labels?.length ? labels : null
                                        }
                                    </div>

                                    <div className='actions-item'>
                                        {ActionsButtons(item, idx)}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>

                {
                    showCreatePaymentButton && userPaymentPermissions?.createNewPayments ?
                        <Button
                            color='primary'
                            className="create-payment-button"
                            onClick={() => {
                                this.setState({ createPaymentModal: true })
                            }}>
                            <Isvg src={addIcon} /> {'Create payment'.translate(this.props.lang)}
                        </Button>
                        :
                        null
                }
                {
                    this.state.cancelPaymentModal ?
                        <CancelPayment
                            {...this.props}
                            isOpen={this.state.cancelPaymentModal?._id}
                            onClose={(callback) => {
                                this.setState({ cancelPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        /> : null
                }
                {
                    this.state.createPaymentModal ?
                        <CreatePayment
                            {...this.props}
                            isOpen={this.state.createPaymentModal}
                            patientId={patientId}
                            hideSelectPatient={true}
                            caseId={this.props.caseId}
                            disableCaseSelection={true}
                            onClose={(callback) => {
                                this.setState({ createPaymentModal: false }, () => {
                                    this.get();
                                    setTimeout(() => {
                                        this.get();
                                    }, 5000);
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.paymentNotes ?
                        <Modal size='lg' centered isOpen={this.state.paymentNotes}>
                            <ModalHeader style={{ paddingBottom: 0 }}> {'Notes'.translate(this.props.lang)} </ModalHeader>
                            <ModalBody className="delete-modal">
                                {
                                    this.state.paymentNotes?.patientNotes ?
                                        <div className='patient-notes-preview-wrap'>
                                            <PatientNotesPreview
                                                {...this.props}
                                                isOpen={this.state.showPatientNotes}
                                                items={this.state.paymentNotes?.patientNotes}
                                                paymentNumber={this.state.paymentNotes?.paymentNumber}
                                                paymentId={this.state.paymentNotes?.paymentId}
                                                caseId={this.state.patientNotesReferralId}
                                                toggle={() => { }
                                                }
                                                showInModal={false}
                                            />
                                        </div>
                                        :
                                        this.state.paymentNotes?.notes && this.state.paymentNotes?.notes.length ?
                                            <ul style={{ listStyle: 'none', padding: 5, textAlign: 'left' }}>
                                                {
                                                    this.state.paymentNotes.notes.map((note, i) => {
                                                        let name;
                                                        note.username ? (name = note.username) : (name = note.name);
                                                        let date;
                                                        if (note.timestamp) {
                                                            try {
                                                                let dateObj = new Date(note.timestamp);
                                                                // console.log(dateObj);
                                                                if (dateObj) {
                                                                    date = `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()}`
                                                                }
                                                            } catch (err) {
                                                                console.log('date err: ', err);
                                                            }

                                                        }
                                                        let message;
                                                        switch (note.action) {
                                                            case 'unpaid-to-paid': message = 'marked this case as paid on'.translate(this.props.lang); break;
                                                            case 'paid-to-unpaid': message = 'marked this case as unpaid on'.translate(this.props.lang); break;
                                                            case 'new-note': message = 'added a new note on'.translate(this.props.lang)
                                                        }

                                                        let addedNote;
                                                        if (note.note && note.note !== '' && note.note.trim() !== '') {
                                                            if (note.action === 'new-note') {
                                                                addedNote = ': ' + `"${note.note}"`
                                                            } else {
                                                                addedNote = ', ' + 'with note'.translate(this.props.lang) + ': ' + `"${note.note}"`;
                                                            }
                                                        }
                                                        let string;
                                                        if (name && message && date) {
                                                            string = name + ' ' + message + ' ' + date;
                                                            if (addedNote) string += addedNote;
                                                        }
                                                        return <li key={i}> {i + 1 + '. '
                                                        } {' '} {string ? string + '.' : 'Note'.translate(this.props.lang)} </li>
                                                    })}
                                            </ul>
                                            :
                                            <div style={{ marginBottom: 20, display: 'flex', fontStyle: 'italic' }}> {'There are still no notes added.'.translate(this.props.lang)} </div>
                                }
                                <Input type="textarea" placeholder={'Enter new note'.translate(this.props.lang)} style={{ height: 100 }} value={this.state.notesPaymentText} onChange={(e) => { this.setState({ notesPaymentText: e.target.value }) }} />
                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    disabled={!this.state.notesPaymentText || this.state.notesPaymentText === '' || this.state.notesPaymentText.trim() === '' || this.state.loadingAddNote}
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => {
                                        this.addNewNote();
                                    }}
                                > {'Save'.translate(this.props.lang)} </Button>

                                <Button
                                    color="primary"
                                    style={{ margin: 10 }}
                                    onClick={() => this.setState({ paymentNotes: null, notesPaymentText: '' })}
                                >
                                    {'Close'.translate(this.props.lang)}
                                </Button>

                            </ModalFooter>
                        </Modal> : null}

                {
                    this.state.statusHistoryModal ? <ReferralStatusHistoryModal
                        isOpen={this.state.statusHistoryModal}
                        currency={this.props.currency}
                        onClose={() => this.setState({ statusHistoryModal: null })}
                        history={this.state.statusHistoryModal?.caseData?._id ?? this.state.statusHistoryModal?._id}
                        lang={this.props.lang}
                        country={this.props.country}
                        getStringDateTs={this.props.getStringDateTs}
                    /> : null
                }
                {
                    this.state.previewPayment ?
                        <PreviewPayment
                            {...this.props}
                            isOpen={this.state.previewPayment?._id}
                            onClose={(callback) => {
                                this.setState({ previewPayment: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.markAsUnpaidModal ?
                        <MarkAsUnpaid
                            {...this.props}
                            isOpen={this.state.markAsUnpaidModal?._id}
                            onClose={(callback) => {
                                this.setState({ markAsUnpaidModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null

                }
                {
                    this.state.addLabelModal ?
                        <AddLabel
                            {...this.props}
                            isOpen={this.state.addLabelModal}
                            onClose={(callback) => {
                                this.setState({ addLabelModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.refundPaymentModal ?
                        <RefundPayment
                            {...this.props}
                            isOpen={this.state.refundPaymentModal}
                            onClose={(callback) => {
                                this.setState({ refundPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.markAsPaidModal ?
                        <MarkAsPaid
                            {...this.props}
                            isOpen={this.state.markAsPaidModal?._id}
                            onClose={(callback) => {
                                this.setState({ markAsPaidModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null

                }
                {
                    this.state.registerPaymentModal ?
                        <RegisterPayment
                            {...this.props}
                            isOpen={this.state.registerPaymentModal?._id}
                            onClose={(callback) => {
                                this.setState({ registerPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.adjustFreeCardCoverageModal ?
                        <AdjustFreeCardCoverage
                            {...this.props}
                            isOpen={this.state.adjustFreeCardCoverageModal}
                            onClose={(callback) => {
                                this.setState({ adjustFreeCardCoverageModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }

                {
                    this.state.editPaymentModal ?
                        <EditPayment
                            {...this.props}
                            isOpen={this.state.editPaymentModal}
                            onClose={(callback) => {
                                this.setState({ editPaymentModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.removeAttachedInvoiceModal ?
                        <RemoveAttachedInvoice
                            {...this.props}
                            isOpen={this.state.removeAttachedInvoiceModal?._id}
                            onClose={(callback) => {
                                this.setState({ removeAttachedInvoiceModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }
                {
                    this.state.attachInvoiceModal ?
                        <AttachInvoice
                            {...this.props}
                            isOpen={this.state.attachInvoiceModal?._id}
                            onClose={(callback) => {
                                this.setState({ attachInvoiceModal: null }, () => {
                                    this.get();
                                    if (callback) {
                                        callback();
                                    }
                                });
                            }}
                        />
                        :
                        null
                }


            </div>
        );
    }
}


export default EventPreviewPaymentField;
